import A1 from './A1Icon';
import Appointment from './AppointmentIcon';
import ArrowLeft from './ArrowLeftIcon';
import ArrowRight from './ArrowRightIcon';
import Close from './CloseIcon';
import CityPhone from './CityPhoneIcon';
import EmailIcon from './IconEmail';
import Fb from './FbIcon';
import Insta from './InstaIcon';
import LocationIcon from './IconLocation';
import Logo from './LogoIcon';
import Mail from './MailIcon';
import Men from './MenIcon';
import Mts from './MtsIcon';
import Pin from './PinIcon';
import Phone from './PhoneIcon';
import PhoneBig from './PhoneBigIcon';
import PhoneIcon from './IconPhone';
import Search from './SearchIcon';
import Time from './TimeIcon';
import TimeIcon from './IconTime';
import Telegram from './TelegramIcon';
import Star from './IconStar';
import UpIcon from './IconUp';
import Viber from './ViberIcon';
import Whatsapp from './WhatsappIcon';
import WhatsappIcon from './IconWhatsapp';
import WebSecret from './WebSecret';
import Women from './WomenIcon';
import Youtube from './YoutubeIcon';

const Icon = (props) => {
  switch (props.name) {
    case 'a1':
      return <A1 {...props} />;
    case 'appointment':
      return <Appointment {...props} />;
    case 'arrow-left':
      return <ArrowLeft {...props} />;
    case 'arrow-right':
      return <ArrowRight {...props} />;
    case 'city-phone':
      return <CityPhone {...props} />;
    case 'close':
      return <Close {...props} />;
    case 'email-icon':
      return <EmailIcon {...props} />;
    case 'fb':
      return <Fb {...props} />;
    case 'insta':
      return <Insta {...props} />;
    case 'location-icon':
      return <LocationIcon {...props} />;
    case 'logo':
      return <Logo {...props} />;
    case 'mail':
      return <Mail {...props} />;
    case 'man':
      return <Men {...props} />;
    case 'mts':
      return <Mts {...props} />;
    case 'pin':
      return <Pin {...props} />;
    case 'phone':
      return <Phone {...props} />;
    case 'phone-big':
      return <PhoneBig {...props} />;
    case 'phone-icon':
      return <PhoneIcon {...props} />;
    case 'search':
      return <Search {...props} />;
    case 'star':
      return <Star {...props} />;
    case 'time':
      return <Time {...props} />;
    case 'time-icon':
      return <TimeIcon {...props} />;
    case 'telegram':
      return <Telegram {...props} />;

    case 'up-icon':
      return <UpIcon {...props} />;
    case 'viber':
      return <Viber {...props} />;
    case 'whatsapp':
      return <Whatsapp {...props} />;
    case 'whatsapp-icon':
      return <WhatsappIcon {...props} />;
    case 'websecret':
      return <WebSecret {...props} />;
    case 'woman':
      return <Women {...props} />;
    case 'youtube':
      return <Youtube {...props} />;
    default:
      return null;
  }
};

export default Icon;
